import { useEffect, useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "@/App.css";
import { api } from "./lib/api";
import { Loading } from "./components/Primitives";
import AppShell from "./components/AppShell";
import WhatsAppBubble from "./components/WhatsAppBubble";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Libraries from "./pages/Libraries";
import LibraryDetail from "./pages/LibraryDetail";
import SubscriptionPlans from "./pages/SubscriptionPlans";
import Invoices from "./pages/Invoices";
import Students from "./pages/Students";
import Seats from "./pages/Seats";
import Shifts from "./pages/Shifts";
import Books from "./pages/Books";
import Attendance from "./pages/Attendance";
import Payments from "./pages/Payments";
import Bills from "./pages/Bills";
import Staff from "./pages/Staff";
import Reports from "./pages/Reports";
import Notifications from "./pages/Notifications";
import Settings from "./pages/Settings";
import StudentDetail from "./pages/StudentDetail";
import AuditLog from "./pages/AuditLog";

const MAIN_ADMIN_ROUTES = [
  { path: "libraries", element: Libraries },
  { path: "libraries/:id", element: LibraryDetail },
  { path: "invoices", element: Invoices },
];
const LIBRARY_ROUTES = [
  { path: "students", element: Students },
  { path: "students/:id", element: StudentDetail },
  { path: "seats", element: Seats },
  { path: "shifts", element: Shifts },
  { path: "books", element: Books },
  { path: "attendance", element: Attendance },
  { path: "payments", element: Payments },
  { path: "bills", element: Bills },
  { path: "staff", element: Staff },
  { path: "reports", element: Reports },
];

export default function App() {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    api
      .get("/auth/me")
      .then((response) => setUser(response.data.user))
      .catch(() => setUser(null))
      .finally(() => setChecking(false));
  }, []);

  if (checking) return <Loading />;

  const staffCan = (module) => {
    if (user?.role !== "STAFF") return true;
    return (user?.permissions?.[module] || []).length > 0;
  };
  const routes = (user?.role === "MAIN_ADMIN" ? MAIN_ADMIN_ROUTES : LIBRARY_ROUTES).filter((route) =>
    staffCan(route.path.split("/")[0].replace(/:.*/, ""))
  );

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={user ? <Navigate to="/dashboard" replace /> : <Landing />} />
        <Route path="/login" element={user ? <Navigate to="/dashboard" replace /> : <Login onLogin={setUser} />} />
        <Route
          path="/"
          element={user ? <AppShell user={user} onLogout={() => setUser(null)} /> : <Navigate to="/login" replace />}
        >
          <Route path="dashboard" element={<Dashboard user={user} />} />
          {routes.map((route) => {
            const Component = route.element;
            return <Route key={route.path} path={route.path} element={<Component user={user} />} />;
          })}
          {staffCan("notifications") ? <Route path="notifications" element={<Notifications user={user} />} /> : null}
          {user?.role === "MAIN_ADMIN" ? <Route path="subscriptions" element={<SubscriptionPlans user={user} />} /> : null}
          {staffCan("settings") ? <Route path="settings" element={<Settings user={user} />} /> : null}
          {user?.role === "MAIN_ADMIN" ? <Route path="audit" element={<AuditLog user={user} />} /> : null}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route>
      </Routes>
      <WhatsAppBubble />
    </BrowserRouter>
  );
}
